
import { defineComponent, reactive, toRefs, onMounted, watch } from 'vue'
import fileDownload from 'js-file-download'
import axios from 'axios'
import { ElMessage } from 'element-plus'
import { getToken } from '@/utils/auth'
import { setBaseUrl } from '@/config/url'
import moment from 'moment'

export default defineComponent({
  name: 'EnterpriseExportContractDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    companyUuid: {
      type: String,
      default: ''
    }
  },
  setup(props, { emit }) {
    const data = reactive({
      dialogVisible: props.visible,
      contractStartTime: null as string | null,
      contractEndTime: null as string | null,
      contractStatusList: [1, 2] as number[],
      loading: false
    })

    const setDefaultDateRange = () => {
      const startOfMonth = moment().startOf('month').format('YYYY-MM-DD HH:mm:ss')
      const endOfMonth = moment().endOf('month').format('YYYY-MM-DD HH:mm:ss')
      data.contractStartTime = startOfMonth
      data.contractEndTime = endOfMonth
    }

    onMounted(() => {
      setDefaultDateRange()
    })

    watch(() => props.visible, (newVal) => {
      data.dialogVisible = newVal
      if (newVal) {
        setDefaultDateRange()
        data.contractStatusList = [1, 2]
      }
    })

    const handleClose = () => {
      data.contractStartTime = null
      data.contractEndTime = null
      emit('update:visible', false)
    }

    const handleDownload = (res: any): void => {
      const fileName = '企业违章合同车辆导出.xlsx'
      const temp = res.headers['content-disposition']?.split(';')[1]?.split('filename=')[1]
      const _fileName = fileName || decodeURIComponent(temp)
      if (res.data instanceof Blob && res.data.type) {
        fileDownload(res.data, _fileName)
        ElMessage.success('导出成功')
        handleClose()
      } else {
        ElMessage.error('导出失败')
      }
    }

    const handleConfirm = () => {
      data.loading = true

      const params: any = {
        companyUuid: props.companyUuid,
        contractStatusList: data.contractStatusList
      }

      if (data.contractStartTime && data.contractEndTime) {
        const formattedStart = moment(data.contractStartTime).format('YYYY-MM-DD HH:mm:ss')
        let formattedEnd = moment(data.contractEndTime).format('YYYY-MM-DD HH:mm:ss')

        if (formattedEnd.endsWith(' 00:00:00')) {
          formattedEnd = moment(data.contractEndTime).format('YYYY-MM-DD') + ' 23:59:59'
        }

        params.contractStartTimeStart = formattedStart
        params.contractStartTimeEnd = formattedEnd
      }

      axios({
        method: 'post',
        headers: {
          token: getToken()
        },
        baseURL: setBaseUrl().baseUrl + '/ccclubs-admin',
        url: '/admin/enterprise/exportViolationContractCar',
        responseType: 'blob',
        data: params
      })
        .then(res => {
          data.loading = false
          if (res.data.type === 'application/json') {
            const reader = new FileReader()
            reader.readAsText(res.data, 'utf-8')
            reader.onload = () => {
              const readerRes: any = reader.result
              const parseObj = JSON.parse(readerRes)
              ElMessage.error(parseObj.msg || '导出失败')
            }
            return false
          }
          handleDownload(res)
        })
        .catch(err => {
          data.loading = false
          ElMessage.error(err.message || '导出失败')
        })
    }

    return {
      ...toRefs(data),
      handleClose,
      handleConfirm
    }
  }
})
